var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full",class:_vm.vueAppClasses,attrs:{"id":"app"}},[_c(_vm.$store.getters.getLayout,{key:_vm.$store.getters.getLayout,tag:"component",on:{"setAppClasses":_vm.setAppClasses}}),_c('transition',{attrs:{"name":"fade-bottom"}},[(_vm.$store.state.chat.display)?_c('Chat'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }